export default
  {
    // 查询可销售的旅行卡列表
    async selectTcardConfigList(params) {
      let actiontype = 'selectTcardConfigList';
      return await this.fetch(actiontype, params);
    },
    // 购买旅行卡接口
    async createTravelCardSaleOrder(params) {
      let actiontype = 'TravelCard_createTravelCardSaleOrder';
      return await this.fetch(actiontype, params);
    },
    // 我的旅行卡订单列表
    async getMyTcardOrderList(params) {
      let actiontype = 'getMyTcardOrderList';
      return await this.fetch(actiontype, params);
    },
    // 我的旅行卡订单详情
    async getMyTcardOrderDetail(params) {
      let actiontype = 'getMyTcardOrderDetail';
      return await this.fetch(actiontype, params);
    },
    // 我的使用明细
    async getClientChangeRecords(params) {
      let actiontype = 'getClientChangeRecords';
      return await this.fetch(actiontype, params);
    },
    // 旅行卡退款
    async createRefundTravelOrder(params) {
      let actiontype = 'TravelOrder_createRefundTravelOrder';
      return await this.fetch(actiontype, params);
    },
    // 机票预订可用旅行卡
    async getTcardForBookTicket(params) {
      let actiontype = 'getTcardForBookTicket';
      return await this.fetch(actiontype, params);
    },
  }


// WEBPACK FOOTER //
// ./src/interfaces/modules/travelCard.js